<template>
  <div class="productViewPortal" :class="[templateName]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "productViewPortal",
  mounted() {
    if (this.$root.env === 'frontend') {
      document.body.querySelector('#lovemap-map').replaceWith(this.$el);
    }
  },
  computed: {
    templateName() {
      return window.lovemap?.templateName || window.mapData?.template || (!window.mapData ? 'lovemap' : false);
    }
  },

}
</script>

<style scoped>

</style>
